import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
declare var $;
@Component({
  selector: 'sort-component',
  templateUrl: './sort.component.html'
})
export class SortComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }
  public Data;
  public rootUrl = this.config.rootUrl;
  ngOnInit() {
    this.baseApi.apiGet('v1/asset/industries',{all:true}).then((i_res)=>{
      if(i_res){
        this.Data = i_res;
      }else{
        this.Data = [];
      }
      //console.log(i_res);
    });
  }
  SetSearch(item){
    if(item.hasEvent){
      var Query = {
        main:1,//產業
        select:item['id'],
        name:item['name']
      }
      this.jslib.SetStorage('search',Query);
      this.route.navigateByUrl('/search');
    }
  }
}
